import { List, ListItem, Typography, Divider } from "@mui/material"
import { FilterRadioGroup } from "components/inputs/FilterFields"

/**
 * List all category in data grid
 */
export const CategoryListFilter = ({ filters = [], setFilters }) => {

    const handleChange = (name, data) => {
        const others = filters.filter((item) => item.field != name)
        setFilters(others.concat(data))
    }

    const status = [
        { value: 'active', text: 'Active' },
        { value: 'inactive', text: 'Inactive' },
    ]

    return (
        <List>
            <ListItem>
                <Typography variant="h5">Filter Categories</Typography>
            </ListItem>
            
            <Divider flexItem />
            <ListItem>
                <FilterRadioGroup name="status" data={status} label="Status" filters={filters} onChange={handleChange} />
            </ListItem>
        </List>
    )
}

